import Settings from '@/modules/settings-page'

export default function UpdateMyProfile() {
    return (
        <>
            <Settings />
        </>
    )
}
